
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Icon } from './Icon';

const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <button
            onClick={toggleTheme}
            className="relative h-9 w-16 rounded-full bg-slate-200 dark:bg-slate-700 p-1 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-slate-800"
            aria-label="Toggle Dark Mode"
        >
            {/* Track Icons (Background) */}
            <div className="absolute inset-0 flex items-center justify-between px-2 text-xs">
                <Icon name="light_mode" className={`!text-[18px] transition-opacity duration-300 ${isDark ? 'opacity-100 text-slate-400' : 'opacity-0'}`} />
                <Icon name="dark_mode" className={`!text-[18px] transition-opacity duration-300 ${isDark ? 'opacity-0' : 'opacity-100 text-slate-400'}`} />
            </div>

            {/* Sliding Circle */}
            <div
                className={`
                    absolute top-1 left-1 h-7 w-7 rounded-full shadow-md flex items-center justify-center transform transition-all duration-300 ease-in-out
                    ${isDark ? 'translate-x-7 bg-primary' : 'translate-x-0 bg-secondary'}
                `}
            >
                <Icon name={isDark ? 'dark_mode' : 'light_mode'} className={`!text-[18px] text-white transition-transform duration-500 ${isDark ? 'rotate-0' : 'rotate-180'}`} />
            </div>
        </button>
    );
};

export default ThemeToggle;

